import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Slider from 'components/sliders/OffsetSlider';
import Thumbnail from 'components/Thumbnail';
import { useLightbox } from 'hooks/useLightbox';

import CommonPropTypes from 'utils/propTypes/common';

import styles from './styles.module.scss';

const Gallery = ({ materials }) => {
	const maxHeightImage = 330;
	const fontSizeDesktop = 10;
	const files = materials.reduce((memo, key) => {
		let newFiles = memo;

		if (key.type === 'photo' && !_(key.files).isEmpty()) {
			newFiles = newFiles.concat(key.files);
		}

		return newFiles;
	}, []);

	const [lightbox, showLightbox] = useLightbox(files);

	return (
		<>
			<Slider containerWidth="narrow" withNavigation>
				{files.map((file, index) => (
					// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
					<div
						key={file._id}
						onClick={() => showLightbox(index)}
						className={styles.item}
						style={{
							width: `${
								((file.width / file.height) * maxHeightImage) / fontSizeDesktop
							}em`
						}}
					>
						<Thumbnail
							file={file}
							alt={file.meta?.title}
							params={{
								height: maxHeightImage
							}}
							placeholder={<span className={styles.placeholder}></span>}
							className={styles.boxImage}
							imgClassName={styles.img}
						/>
					</div>
				))}
			</Slider>
			{lightbox}
		</>
	);
};

Gallery.propTypes = {
	materials: PropTypes.arrayOf(CommonPropTypes.file).isRequired
};

export default Gallery;
